export default "__VITE_ASSET__DRkafnk7__"